<template>
    <LandingPage>
      <template slot="taption_header">
        <div id="text1-strings">
          <p>Transkripsi</p>
          <p>ChatGPT untuk</p>
          <p>Terjemahkan</p>
          <p>Tambahkan subtitle ke</p>
        </div>
        <span id="text1"></span>video Anda.</template>
      <template slot="landing_description">Secara otomatis membuat transkripsi, terjemahan, subtitle, dan menganalisis video Anda dalam lebih dari 40 bahasa.</template>

      <template slot="intro_video">
    
          <video playsinline class="intro-video" :src='"@/assets/video/landing_en.mp4"' autoplay frameborder="0" height="350" width="575" muted></video>
      </template>

      <template slot="start_your_trial">COBA TAPTION</template>

      <template slot="use_case_title">Fitur produk.</template>
      <template slot="youtubers">Ubah video menjadi teks</template>
      <template slot="youtubers_question">Transkripsi video Anda dan secara otomatis menghasilkan caption dan subtitle</template>


      <template slot="journalists">Analisis AI</template>
      <template slot="journalists_question">Ringkas video, hasilkan topik, dan buat bab YouTube. Miliki ChatGPT kustom Anda sendiri</template>
     
      <template slot="translators">Terjemahkan video</template>
      <template slot="translators_question">Terjemahkan subtitle dan transkripsi Anda ke lebih dari 50 bahasa</template>

      <template slot="speaker">Pelabelan pembicara</template>
      <template slot="speaker_question">Ubah audio menjadi teks dan beri label pembicara dalam rekaman Anda</template>

      <template slot="audiotomp4">Ubah audio Anda menjadi video</template>
      <template slot="audiotomp4_question">Gunakan file audio dan gambar Anda untuk mengubahnya menjadi video MP4 dengan caption</template>

      <template slot="importsrt">Ubah TXT menjadi SRT</template>
      <template slot="importsrt_question">Tambahkan timestamp ke teks dan format secara otomatis.</template>

      <template slot="share">Berkolaborasi dengan tim</template>
      <template slot="share_question">Bagikan akun dan sesuaikan fitur dengan manajemen izin pengguna</template>

      <template slot="learnmore">Pelajari lebih lanjut</template>
      

      <template slot="simple_workflow">Alur kerja sederhana.</template>
      <template slot="upload">Unggah</template>
      <template slot="upload_description">Unggah video Anda ke platform kami atau gunakan generator transkripsi YouTube kami untuk langsung mentranskripsikan dari YouTube. Anda juga dapat mengunggah file dari Zoom, Webex, dan Google Drive.</template>
      <template slot="edit_translate">Edit</template>
      <template slot="edit_translate_description">Edit transkripsi Anda tanpa khawatir menyesuaikan timestamp. Selain itu, editor video online kami memungkinkan Anda langsung mengedit video Anda di platform.</template>
      <template slot="transcribe">Analisis AI</template>
      <template slot="transcribe_description">Ajukan pertanyaan apa pun untuk menanyakan konten video. Kami menyediakan template umum, seperti membuat bab YouTube dengan timestamp, meringkas video, menghasilkan ringkasan YouTube, dan generator topik video.</template>
      <template slot="translate">Terjemahkan</template>
      <template slot="translate_description">Terjemahan online kami mendukung lebih dari 40 bahasa, dengan kinerja yang unggul terutama dalam terjemahan antara bahasa lintas regional seperti Inggris ke Mandarin, Inggris ke Jepang, Inggris ke Vietnam atau sebaliknya.</template>
      <template slot="export">Ekspor</template>
      <template slot="export_description">Setelah menyelesaikan pengeditan subtitle dan video, Anda dapat mengekspor dalam format MP4 dengan subtitle tertanam, SRT, VTT, PDF, dan file TXT.</template>
      <template slot="try_it_now">Coba sekarang</template>


      <template slot="editing_platform_desc1">Fitur timeline Taption menyederhanakan pengeditan video. Ketika pengeditan tumpang tindih dengan subtitle, secara otomatis menyesuaikan teks dan waktu, memastikan akurasi dan sinkronisasi. Editor video online kami sempurna untuk pengeditan cepat, dengan mudah membuat video bersubtitle profesional.</template>
      <template slot="video_time_stampped">
            <div class="video-wrapper" @click="onClicked('video1', true)">
                  <button v-show="!videoState.video1" class="play"></button>
                  <video id="video1" ref="video1" playsinline class="unique-video" poster="../assets/images/thumbnail/cut_thumbnail_en.webp" :src='"@/assets/video/Trim_Cut_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
            </div>
      </template>
      
      <template slot="editing_platform">Platform pengeditan luar biasa.</template>
      <template slot="editing_platform_desc0">Selain pengeditan subtitle dan transkripsi, platform generator subtitle kami memungkinkan pengeditan video yang tepat langsung melalui subtitle. Secara otomatis menyesuaikan waktu subtitle lainnya agar sesuai dengan video yang diedit, memastikan pemutaran yang lancar dan sinkron.</template>
      <template slot="video_trimmed">
            <div class="video-wrapper" @click="onClicked('video0', true)">
                  <div class="play-button" v-show="!videoState.video0">
                    <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
          <video id="video0" ref="video0" playsinline preload="none" class="intro-video" poster="../assets/images/thumbnail/trim_thumbnail_en_US.webp" :src='"@/assets/video/Trim_English.mp4"' frameborder="0" height="350" width="575" muted></video>
            </div>
      </template>

 
      <template slot="editing_platform_desc2">Fitur analisis AI kami meningkatkan pemahaman video dengan membuat ringkasan video, mengidentifikasi poin-poin kunci, dan memungkinkan pencarian konten. Selain itu, fitur ini menawarkan template yang umum digunakan termasuk pembuatan bab YouTube, menghasilkan topik video, dan mengoreksi subtitle, meningkatkan proses pengeditan video.</template>
      <template slot="video_replace_all">
          <div class="video-wrapper" @click="onClicked('video2', true)">
              <div class="play-button" v-show="!videoState.video2">
                    <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
              <video id="video2" ref="video2" playsinline preload="none" poster="../assets/images/thumbnail/analysis_thumbnail_en.webp" class="unique-video" :src='"@/assets/video/AI_Analysis_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
          </div>
      </template>
      <template slot="editing_platform_desc3">Memo memungkinkan Anda menambahkan catatan pada timestamp tertentu dalam transkripsi video Anda, membuat catatan untuk dilihat pengguna lain. Pengguna dapat dengan cepat menavigasi ke segmen video yang sesuai menggunakan memo ini, meningkatkan proses konversi video ke teks. Alat ini berguna untuk pengeditan video, menghasilkan subtitle, dan membuat bab atau ringkasan YouTube.</template>
      <template slot="video_add_dictionary">
        <div class="video-wrapper" @click="onClicked('video3', true)">
              <div class="play-button" v-show="!videoState.video3">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
              <video id="video3" ref="video3" playsinline preload="none" poster="../assets/images/thumbnail/memo_thumbnail_en.webp" class="unique-video" :src='"@/assets/video/Memo_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
          </div>
      </template> 

                   

      <template slot="low_cost">Harga terjangkau.</template>
      <template slot="title_basic">Bayar sesuai penggunaan</template>
      <template slot="basic_cost_usd">$8 USD</template>
      <template slot="basic_cost_ntd">(240 NTD)</template>
      <template slot="hour">jam</template>
      <template slot="basic_feature5">Kredit <span style="color: #00d1b2;">60 menit</span></template>
      <template slot="basic_feature1">Transkripsi otomatis</template>
      <template slot="basic_feature2">Mendukung lebih dari 40 bahasa</template>
      <template slot="basic_feature3">Editor teks dengan sorotan</template>
      <template slot="basic_feature4">Terjemahkan ke lebih dari 50 bahasa</template>
      <template slot="basic_feature7">Kamus AI Pribadi</template>
      <template slot="basic_feature6">Diizinkan untuk penggunaan komersial</template>
      <template slot="basic_feature8">Mendukung subtitle multi-bahasa yang tertanam</template>

      <template slot="title_premium">Langganan Premium</template>
      <template slot="premium_cost_usd">$12 USD</template>
      <template slot="premium_cost_ntd">(360 NTD)</template>
      <template slot="premium_basic_cost_usd">$6 USD</template>
      <template slot="month">bulan</template>

      <template slot="premium_before"><span class="landing-arrow-left">&#10229;</span>Semua fitur dalam「Bayar sesuai penggunaan」</template>
      <template slot="premium_feature1">Kredit <span style="color: #00d1b2;">120 menit</span> ke akun Anda setiap bulan.<br><span style="color:#797676;font-size:14px;font-weight: 100;">(Menit dapat diakumulasi, berlaku hingga langganan dibatalkan)</span></template>
      <template slot="premium_feature1_tooltip">Jika menit bulanan tidak terpakai, akan diakumulasikan ke bulan berikutnya dan berlaku hingga langganan dibatalkan. <br>Menit bulanan ini digunakan sebelum menit tambahan yang dibeli secara terpisah. <br>Menit tambahan yang dibeli secara terpisah tidak kedaluwarsa setelah langganan dibatalkan.</template>
      <template slot="premium_feature2">Diskon 25% untuk pembelian per jam</template>
      <template slot="premium_feature3">Ekspor subtitle tertanam tak terbatas secara gratis</template>
      <template slot="premium_feature4">Berbagi transkripsi yang dapat diedit</template>
      <template slot="premium_feature5">Ekspor rekaman audio Anda menjadi video dengan subtitle</template>
      <template slot="premium_feature6">Pemotongan video (Transkripsi/subtitle yang diekspor akan otomatis menyesuaikan)</template>

      <template slot="title_corp">Langganan Massal</template>
      <template slot="bulk_cost_usd">$69 USD</template>
      <template slot="bulk_cost_ntd">(2070 NTD)</template>
      <template slot="bulk_basic_cost_usd">$4 USD</template>
      <template slot="bulk_before"><span class="landing-arrow-left">&#10229;</span>Semua fitur dalam「Bayar sesuai penggunaan」dan「Langganan Premium」</template>
       <template slot="bulk_feature2">Diskon 63% untuk pembelian per jam</template>
      <template slot="premium_feature1_bulk">Kredit <span style="color: #00d1b2;">1000 menit</span> ke akun Anda setiap bulan.<br><span style="color:#797676;font-size:14px;font-weight: 100;">(Menit dapat diakumulasi, berlaku hingga langganan dibatalkan)</span></template>
      <template slot="bulk_feature1">Menyediakan unduhan kwitansi dengan nama institusi dan NPWP Anda</template>

       <template slot="bulk_feature3">Berbagi menit dengan pengguna</template>
       <template slot="bulk_feature4">6 izin yang dapat dikonfigurasi berbeda</template>

      <template slot="go_to_price">Rincian lebih lanjut</template>
    </LandingPage>
</template>

<script>
import LandingPage from "./LandingPage";
//import Typed from 'typed.js';
export default {
  data: () => ({
      videoState:{
          video0:false,
          video1:false,
          video2:false,
          video3:false  
      }
  }),
  components: {
    LandingPage
  },
  methods: {
    onClicked(videoType, isPlay){
        const me = this;
        me.$refs[videoType].play();
        me.videoState[videoType] = isPlay;
    }
  },
  mounted(){
    const me = this;
    const video0 = document.getElementById("video0");  
    const video1 = document.getElementById("video1");   
    const video2 = document.getElementById("video2");   
    const video3 = document.getElementById("video3");   

    if(video0){
        video0.onended = function() {
            me.videoState.video0 = false;
        }
        // video0.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video0 = false;
        // } 
    }

    if(video1){
        video1.onended = function() {
            me.videoState.video1 = false;
        }
        // video1.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video1 = false;
        // } 
    }

    if(video2){
        video2.onended = function() {
            me.videoState.video2 = false;
        } 
        // video2.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video2 = false;
        // } 
    }


    if(video3){
        video3.onended = function() {
            me.videoState.video3 = false;
        } 
        // video3.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video3 = false;
        // } 
    }
  }
}

</script>


           